module.exports = __webpack_public_path__ + "img/sales.93ddb3c8.svg";